module.exports = __webpack_public_path__ + "h5/img/master_8.a71dbf14.jpg";